import { j as d } from "./jsx-runtime-3tyXYecC.mjs";
import { useRef as S, useEffect as I, useState as B, useMemo as Q, cloneElement as W } from "react";
import { m as N } from "./tss-DN0acMKN.mjs";
import { M as P, d as M } from "./constants-CnFYFetN.mjs";
import { c as z } from "./index-DkZ16bcJ.mjs";
import { I as O } from "./icon-button-BxDvkq_l.mjs";
function U(i, e, t) {
  return `calc(((100% - (${e - 1} * ${i})) / ${e}) * ${t} + (${i} * ${t - 1}))`;
}
function X(i, e, t) {
  return `calc((-100% - ${i}) / ${e} * ${t})`;
}
const k = ({
  difference: i,
  numSlides: e,
  slidesToShow: t = Math.abs(i),
  currentIndex: n,
  setCurrentIndex: s
}) => {
  const r = Math.max(e - t, 0);
  let o = n + i;
  o < 0 ? o = 0 : o > r && (o = r), o !== n && s(o);
};
class A {
  constructor() {
    this._slidesToShow = 0;
  }
  _createObserver() {
    var e;
    this._element && (this._observer = new window.ResizeObserver((t) => {
      for (const n of t) {
        if (!this._breakpoints)
          return;
        const s = n.borderBoxSize[0].inlineSize - this._buttonWidth, l = Object.keys(this._breakpoints).map(Number).sort((a, m) => m - a), r = Number(l.find((a) => a <= s) || "0"), o = this._breakpoints[r] || 1;
        o !== this._slidesToShow && typeof this._onResize == "function" && (this._slidesToShow = o, this._onResize(o));
      }
    }), (e = this._observer) == null || e.observe(this._element));
  }
  _update() {
    !this._element && this._observer ? this.disconnect() : !this._breakpoints && this._observer ? this.disconnect() : this._element && this._breakpoints && !this._observer && this._createObserver();
  }
  setElement(e) {
    this._element = e, this._update();
  }
  setBreakpoints(e) {
    const t = !this._breakpoints && e || this._breakpoints && !e;
    this._breakpoints = e, t && this._update();
  }
  setOnResize(e) {
    this._onResize = e;
  }
  setButtonWidth(e) {
    this._buttonWidth = e;
  }
  disconnect() {
    this._observer && (this._observer.disconnect(), this._observer = void 0);
  }
}
function E({ elementRef: i, breakpoints: e, onResize: t, carouselButtonWidth: n }) {
  const s = S(new A());
  return s.current.setButtonWidth(n), s.current.setOnResize(t), s.current.setBreakpoints(e), I(() => {
    const l = s.current;
    return l.setElement(i.current), () => {
      l.disconnect();
    };
  }, [i]), s.current;
}
const q = N()(({ mode: i }, { isSinglePage: e }) => ({
  baseContainer: {
    flex: "1 1 100%",
    margin: e ? "0" : " 0 16px",
    minWidth: 0,
    order: 2,
    outline: i === P.Dye ? `1px solid ${M.main}` : void 0
  },
  button: {
    alignItems: "center",
    display: "flex",
    flex: "0 0 auto"
  },
  hideButton: {
    opacity: 0,
    display: "none"
  },
  nextButton: {
    order: 3
  },
  prevButton: {
    order: 1
  },
  wrapper: {
    display: "flex"
  }
})), H = N()((i, e) => {
  const { mode: t } = i, { singlePageSlideAlignment: n = "center" } = e, s = {
    center: "auto",
    left: "0",
    right: "auto"
  }, l = {
    center: "auto",
    left: "auto",
    right: "0"
  };
  return {
    container: {
      outline: t === P.Dye ? `1px solid ${M.main}` : void 0,
      overflowX: "hidden"
    },
    hideSlide: {
      transitionDuration: "0.3s",
      transitionProperty: "visibility",
      transitionTimingFunction: "ease-in-out",
      visibility: "hidden"
    },
    slider: {
      display: "grid",
      gridAutoFlow: "column",
      gridAutoColumns: "minmax(0, 1fr)",
      marginLeft: s[n],
      marginRight: l[n],
      position: "relative",
      transitionDuration: "0.3s",
      transitionProperty: "left",
      transitionTimingFunction: "ease-in-out"
    }
  };
});
function L({
  ariaLabelledBy: i,
  containerRef: e,
  containerRole: t = "group",
  currentIndex: n,
  slideGap: s = "0",
  slides: l,
  slidesToShow: r = 1,
  singlePageSlideAlignment: o
}) {
  const { classes: a } = H({ singlePageSlideAlignment: o }), m = U(s, r, l.length), f = X(s, r, n);
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "aria-atomic": !1,
      "aria-labelledby": i,
      "aria-live": "polite",
      "aria-roledescription": "carousel",
      className: a.container,
      ref: e,
      role: t,
      children: /* @__PURE__ */ d.jsx(
        "div",
        {
          className: a.slider,
          style: {
            width: m,
            left: f,
            gridColumnGap: s
          },
          children: l.map((g, _) => {
            const b = _ < n || _ >= n + r;
            return /* @__PURE__ */ d.jsx(
              "div",
              {
                "aria-labelledby": g.ariaLabelledBy,
                "aria-roledescription": "slide",
                className: z({ [a.hideSlide]: b }),
                role: "group",
                children: g.slide
              },
              g.ariaLabelledBy
            );
          })
        }
      )
    }
  );
}
const J = () => /* @__PURE__ */ d.jsx(
  O,
  {
    "aria-label": window.jQuery ? $.__("Next") : "Next",
    color: "secondary",
    icon: "chevron-right-solid",
    type: "button",
    variant: "outlined"
  }
), K = () => /* @__PURE__ */ d.jsx(
  O,
  {
    "aria-label": window.jQuery ? $.__("Previous") : "Previous",
    color: "secondary",
    icon: "chevron-left-solid",
    type: "button",
    variant: "outlined"
  }
);
function R({
  ariaLabelledBy: i,
  containerRole: e,
  nextButton: t = J(),
  prevButton: n = K(),
  singlePageSlideAlignment: s,
  slideGap: l,
  slides: r,
  widthBreakpoints: o = { 0: 1 }
}) {
  const [a, m] = B(0), [f, g] = B(1), _ = S(null), b = S(null), [C, T] = B(0), x = S(null), [j, F] = B(0), v = a <= 0, y = a >= r.length - f, p = r.length <= f, { classes: h } = q({ isSinglePage: p }), D = Q(() => {
    let c = 0;
    return p ? c = j + C : v ? c = j : y && (c = C), c;
  }, [v, y, p, j, C]);
  return E({
    elementRef: _,
    breakpoints: o,
    onResize: (c) => {
      k({
        difference: 0,
        numSlides: r.length,
        slidesToShow: c,
        currentIndex: a,
        setCurrentIndex: m
      }), g(c);
    },
    carouselButtonWidth: D
  }), I(() => {
    x != null && x.current && F(x.current.getBoundingClientRect().width), b != null && b.current && T(b.current.getBoundingClientRect().width);
  }), /* @__PURE__ */ d.jsxs("div", { className: h.wrapper, "data-fabric-component": "Carousel", children: [
    !p && /* @__PURE__ */ d.jsx("div", { className: z(h.prevButton, h.button, { [h.hideButton]: v }), ref: b, children: W(n, {
      onClick: (c) => {
        var u, w;
        return k({
          difference: -f,
          numSlides: r.length,
          currentIndex: a,
          setCurrentIndex: m
        }), (w = (u = n == null ? void 0 : n.props) == null ? void 0 : u.onClick) == null ? void 0 : w.call(u, c);
      },
      disabled: v,
      tabIndex: v ? -1 : 0
    }) }),
    !p && /* @__PURE__ */ d.jsx("div", { className: z(h.nextButton, h.button, { [h.hideButton]: y }), ref: x, children: W(t, {
      onClick: (c) => {
        var u, w;
        return k({
          difference: f,
          numSlides: r.length,
          currentIndex: a,
          setCurrentIndex: m
        }), (w = (u = t == null ? void 0 : t.props) == null ? void 0 : u.onClick) == null ? void 0 : w.call(u, c);
      },
      disabled: y,
      tabIndex: y ? -1 : 0
    }) }),
    /* @__PURE__ */ d.jsx("div", { className: h.baseContainer, children: /* @__PURE__ */ d.jsx(
      L,
      {
        ariaLabelledBy: i,
        containerRef: _,
        containerRole: e,
        currentIndex: a,
        singlePageSlideAlignment: p ? s : "center",
        slideGap: l,
        slides: r,
        slidesToShow: f
      }
    ) })
  ] });
}
R.Base = L;
R.Resizer = A;
R.changeIndex = k;
R.useResizer = E;
export {
  R as C
};
//# sourceMappingURL=carousel-DHJcW-s9.mjs.map
